// admin/src/features/preview/CalibrationPanel.tsx
//
// One-time "real size" setup: the viewer holds any bank card against the
// screen and drags until the outline matches it (85.6 x 53.98 mm on every
// card). The card stands upright when the window is too narrow for it.
import { useEffect, useState } from 'react';
import { Button } from '../../components/Button';
import { CARD_MM } from './devices';
import { CSS_PX_PER_MM_RANGE, clampCssPxPerMm } from './calibration';

export function CalibrationPanel({ initial, onDone }: { initial: number; onDone: (cssPxPerMm: number) => void }) {
  const [value, setValue] = useState(initial);
  const [narrow, setNarrow] = useState(false);

  useEffect(() => {
    const check = () => setNarrow(window.innerWidth < CARD_MM.width * value + 48);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [value]);

  const w = (narrow ? CARD_MM.height : CARD_MM.width) * value;
  const h = (narrow ? CARD_MM.width : CARD_MM.height) * value;
  const nudge = (delta: number) => setValue((v) => clampCssPxPerMm(Number((v + delta).toFixed(3))));

  return (
    <div className="pv-calibrate" onClick={(e) => e.stopPropagation()}>
      <h3>Real size</h3>
      <p className="muted">Hold a bank card on the screen. Drag until it matches.</p>
      <div className="pv-card-outline" style={{ width: w, height: h, borderRadius: CARD_MM.corner * value }}>
        <span className="pv-card-chip" style={{ width: 11 * value, height: 9 * value, borderRadius: 1.5 * value, [narrow ? 'top' : 'left']: 9 * value, [narrow ? 'left' : 'top']: 17 * value }} />
      </div>
      <div className="pv-calibrate-controls">
        <Button tone="neutral" size="sm" onClick={() => nudge(-0.02)} aria-label="Smaller">
          −
        </Button>
        <input
          type="range"
          min={CSS_PX_PER_MM_RANGE.min}
          max={CSS_PX_PER_MM_RANGE.max}
          step={0.005}
          value={value}
          onChange={(e) => setValue(Number(e.target.value))}
          aria-label="Card size"
        />
        <Button tone="neutral" size="sm" onClick={() => nudge(0.02)} aria-label="Bigger">
          +
        </Button>
      </div>
      <Button onClick={() => onDone(value)}>Done</Button>
    </div>
  );
}
